import { useState, useEffect, useCallback } from 'react';

const ONBOARDING_KEY = 'bb_onboarding_claimed';
const TOOLTIP_KEY = 'bb_onboarding_tooltips_shown';

export function useOnboarding(sessionNumber, dispatch, user) {
  const [tooltip, setTooltip] = useState(null);

  useEffect(() => {
    // Only grant on first 3 sessions
    if (sessionNumber > 3) return;

    const claimed = localStorage.getItem(ONBOARDING_KEY);
    if (claimed) return;

    // Grant 3 free Undos + 3 free Bombs for local play
    dispatch({ type: 'SET_POWER_UPS', powerUps: { undo: 3, bomb: 3, refresh: 0 } });
    localStorage.setItem(ONBOARDING_KEY, 'true');

    // For authenticated users, also credit on backend
    if (user) {
      import('../services/api').then(({ apiPost }) => {
        // Will be wired when route is added
        fetch('/payments/grant-onboarding', { method: 'POST' }).catch(() => {});
      }).catch(() => {});
    }
  }, [sessionNumber, dispatch, user]);

  // Show tooltips on first use
  useEffect(() => {
    const shown = localStorage.getItem(TOOLTIP_KEY);
    if (shown) return;

    if (sessionNumber === 1) {
      // Show undo tooltip after a short delay
      const timer = setTimeout(() => {
        setTooltip({ type: 'undo', message: 'Tap to undo your last move' });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [sessionNumber]);

  const dismissTooltip = useCallback(() => {
    setTooltip(null);
    localStorage.setItem(TOOLTIP_KEY, 'true');
  }, []);

  const showBombTooltip = useCallback(() => {
    const shown = localStorage.getItem(TOOLTIP_KEY);
    if (shown) return;
    setTooltip({ type: 'bomb', message: 'Tap then select a cell to clear a 3x3 area' });
  }, []);

  return { tooltip, dismissTooltip, showBombTooltip };
}
